import { InteractionRequiredAuthError } from '@azure/msal-browser';
import {
  loginRequest,
  msalInstance,
  tokenRequest,
} from '../authConfig/authConfig';

export const getToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts === null || accounts.length < 1) {
    sessionStorage.clear();
    return await msalInstance.loginRedirect(loginRequest);
  }

  const activeAccount = msalInstance.getActiveAccount();
  if (activeAccount === null) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
    if (tokenResponse.accessToken === '') {
      sessionStorage.clear();
      return await msalInstance.acquireTokenRedirect(tokenRequest);
    }

    return tokenResponse.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      sessionStorage.clear();
      return await msalInstance.acquireTokenRedirect(tokenRequest);
    }
  }
};

export const fetchWithToken = async (
  input: RequestInfo,
  init?: RequestInit,
): Promise<Response> => {
  const token = await getToken();

  const o = init ?? {};

  o.headers = new Headers(init?.headers);
  o.headers.set('Authorization', `Bearer ${token}`);

  return await fetch(input, o);
};
